import script from "./tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./tabbar.vue?vue&type=script&setup=true&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=08e884ec&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e884ec"]])

export default __exports__